'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _zapIcons = require('@zapsa/zap-icons');

var _zapIcons2 = _interopRequireDefault(_zapIcons);

var _reactOnclickoutside = require('react-onclickoutside');

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _TimeView = require('./TimeView');

var _TimeView2 = _interopRequireDefault(_TimeView);

var _MonthsView = require('./MonthsView');

var _MonthsView2 = _interopRequireDefault(_MonthsView);

var _DaysView = require('./DaysView');

var _DaysView2 = _interopRequireDefault(_DaysView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ZapDatepicker = function (_Component) {
  _inherits(ZapDatepicker, _Component);

  function ZapDatepicker(props) {
    _classCallCheck(this, ZapDatepicker);

    var _this = _possibleConstructorReturn(this, (ZapDatepicker.__proto__ || Object.getPrototypeOf(ZapDatepicker)).call(this, props));

    _this.getStateFromProps = _this.getStateFromProps.bind(_this);
    _this.getInitialState = _this.getInitialState.bind(_this);
    _this.getUpdateOn = _this.getUpdateOn.bind(_this);
    _this.getFormats = _this.getFormats.bind(_this);
    _this.updateTime = _this.updateTime.bind(_this);
    _this.getComponentProps = _this.getComponentProps.bind(_this);
    _this.openCalendar = _this.openCalendar.bind(_this);
    _this.closeCalendar = _this.closeCalendar.bind(_this);
    _this.handleClickOutside = _this.handleClickOutside.bind(_this);
    _this.showView = _this.showView.bind(_this);
    _this.onInputKey = _this.onInputKey.bind(_this);

    _this.viewComponents = {
      days: _DaysView2.default,
      months: _MonthsView2.default,
      time: _TimeView2.default
    };

    _this.componentProps = {
      fromProps: ['value', 'isValidDate', 'renderDay', 'renderMonth', 'renderYear', 'timeConstraints', 'todayButton', 'rangeMode', 'timePicker'],
      fromState: ['viewDate', 'selectedDate', 'selectedDateEnd', 'updateOn'],
      fromThis: ['setDate', 'setTime', 'showView', 'addTime', 'subtractTime', 'updateSelectedDate', 'localMoment', 'setToToday']
    };
    _this.allowedSetTime = ['hours', 'minutes', 'seconds', 'milliseconds'];

    _this.state = _this.getInitialState();
    return _this;
  }

  _createClass(ZapDatepicker, [{
    key: 'getInitialState',
    value: function getInitialState() {
      var state = this.getStateFromProps(this.props);

      if (state.open === undefined) {
        state.open = !this.props.input;
      }
      state.currentView = this.props.dateFormat ? this.props.viewMode || state.updateOn || 'days' : 'time';

      return state;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.onEnter = function (e) {
        if (_this2.props.input && _this2.state.open && !_this2.props.open && (e.keyCode === 13 || e.keyCode === 27)) {
          e.preventDefault();
          _this2.setState({ open: false }, function () {
            _this2.props.onBlur(_this2.state.selectedDate || _this2.state.inputValue);
          });
        }
      };
      document.body.addEventListener('keydown', this.onEnter, false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var formats = this.getFormats(nextProps);
      var updatedState = {};

      if (nextProps.value !== this.props.value || formats.datetime !== this.getFormats(this.props).datetime || nextProps.defaultStart !== this.props.defaultStart) {
        updatedState = this.getStateFromProps(nextProps);
      }

      if (updatedState.open === undefined) {
        if (this.props.closeOnSelect && this.state.currentView !== 'time') {
          updatedState.open = false;
        } else {
          updatedState.open = this.state.open;
        }
      }

      if (nextProps.viewMode !== this.props.viewMode) {
        updatedState.currentView = nextProps.viewMode;
      }

      if (nextProps.locale !== this.props.locale) {
        if (this.state.viewDate) {
          var updatedViewDate = this.state.viewDate.clone().locale(nextProps.locale);
          updatedState.viewDate = updatedViewDate;
        }
        if (this.state.selectedDate) {
          var updatedSelectedDate = this.state.selectedDate.clone().locale(nextProps.locale);
          updatedState.selectedDate = updatedSelectedDate;
          updatedState.inputValue = updatedSelectedDate.format(formats.datetime);
        }
      }

      if (nextProps.utc !== this.props.utc) {
        if (nextProps.utc) {
          if (this.state.viewDate) {
            updatedState.viewDate = this.state.viewDate.clone().utc();
          }
          if (this.state.selectedDate) {
            updatedState.selectedDate = this.state.selectedDate.clone().utc();
            updatedState.inputValue = updatedState.selectedDate.format(formats.datetime);
          }
        } else {
          if (this.state.viewDate) {
            updatedState.viewDate = this.state.viewDate.clone().local();
          }
          if (this.state.selectedDate) {
            updatedState.selectedDate = this.state.selectedDate.clone().local();
            updatedState.inputValue = updatedState.selectedDate.format(formats.datetime);
          }
        }
      }

      this.setState(updatedState);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.onEnter) {
        document.body.removeEventListener('keydown', this.onEnter, false);
      }
    }
  }, {
    key: 'getUpdateOn',
    value: function getUpdateOn(formats) {
      // eslint-disable-line
      if (formats.date.match(/[lLD]/)) {
        return 'days';
      }
      if (formats.date.indexOf('M') !== -1) {
        return 'months';
      }

      return 'days';
    }
  }, {
    key: 'getFormats',
    value: function getFormats(props) {
      var formats = {
        date: props.dateFormat || '',
        time: props.timeFormat || ''
      };
      var locale = this.localMoment(props.date, null, props).localeData();

      if (formats.date === true) {
        formats.date = locale.longDateFormat('L');
      } else if (this.getUpdateOn(formats) !== 'days') {
        formats.time = '';
      }

      if (formats.time === true) {
        formats.time = locale.longDateFormat('LT');
      }

      formats.datetime = formats.date && formats.time ? formats.date + ' ' + formats.time : formats.date || formats.time;

      return formats;
    }
  }, {
    key: 'onInputChange',
    value: function onInputChange(e) {
      var _this3 = this;

      var update = void 0;
      var localMoment = void 0;
      var value = e.target === null ? e : e.target.value;
      if (this && this.localMoment) {
        localMoment = this.localMoment(value, this.state.inputFormat);
        update = { inputValue: value };
      }

      if (localMoment.isValid() && !this.props.value) {
        update.selectedDate = localMoment;
        update.viewDate = localMoment.clone().startOf('month');
      } else {
        update.selectedDate = null;
      }

      return this.setState(update, function () {
        return _this3.props.onChange(localMoment.isValid() ? localMoment : _this3.state.inputValue);
      });
    }
  }, {
    key: 'onInputKey',
    value: function onInputKey(e) {
      if (e.which === 9 && this.props.closeOnTab) {
        this.closeCalendar();
      } else {
        e.preventDefault();
        e.stopPropagation();
      }
    }
  }, {
    key: 'getStateFromProps',
    value: function getStateFromProps(props) {
      var formats = this.getFormats(props);
      var date = props.value || props.defaultValue;
      var selectedDate = void 0;
      var selectedDateEnd = void 0;
      var inputValue = void 0;

      if (date && typeof date === 'string') {
        selectedDate = this.localMoment(date, formats.datetime);
      } else if (date) {
        selectedDate = this.localMoment(date);
      }

      if (selectedDate && !selectedDate.isValid()) {
        selectedDate = null;
      }

      var viewDate = void 0;
      if (props.defaultStart) {
        viewDate = selectedDate ? selectedDate.clone().startOf('month') : this.localMoment(props.defaultStart).clone().startOf('month');
      } else {
        viewDate = selectedDate ? selectedDate.clone().startOf('month') : this.localMoment().startOf('month');
      }
      var updateOn = this.getUpdateOn(formats);

      if (selectedDate) {
        inputValue = selectedDate.format(formats.datetime);
      } else if (date.isValid && !date.isValid()) {
        inputValue = '';
      } else {
        inputValue = date || '';
      }

      return {
        updateOn: updateOn,
        inputFormat: formats.datetime,
        viewDate: viewDate,
        selectedDate: selectedDate,
        selectedDateEnd: selectedDateEnd,
        inputValue: inputValue,
        open: props.open
      };
    }
  }, {
    key: 'showView',
    value: function showView(view) {
      var _this4 = this;

      return function () {
        _this4.setState({ currentView: view });
      };
    }
  }, {
    key: 'setDate',
    value: function setDate(type) {
      var _this5 = this;

      var nextViews = {
        month: 'days',
        year: 'months'
      };

      return function (e) {
        _this5.setState({
          viewDate: _this5.state.viewDate.clone()[type](parseInt(e.target.getAttribute('data-value'), 10)).startOf(type),
          currentView: nextViews[type]
        });
      };
    }
  }, {
    key: 'addTime',
    value: function addTime(amount, type, toSelected) {
      return this.updateTime('add', amount, type, toSelected);
    }
  }, {
    key: 'subtractTime',
    value: function subtractTime(amount, type, toSelected) {
      return this.updateTime('subtract', amount, type, toSelected);
    }
  }, {
    key: 'updateTime',
    value: function updateTime(op, amount, type, toSelected) {
      var _this6 = this;

      return function () {
        var update = {};
        var date = toSelected ? 'selectedDate' : 'viewDate';

        update[date] = _this6.state[date].clone()[op](amount, type);

        _this6.setState(update);
      };
    }
  }, {
    key: 'setTime',
    value: function setTime(type, value) {
      var index = this.allowedSetTime.indexOf(type) + 1;
      var state = this.state;
      var date = (state.selectedDate || state.viewDate).clone();
      var nextType = void 0;

      date[type](value);
      for (; index < this.allowedSetTime.length; index++) {
        nextType = this.allowedSetTime[index];
        date[nextType](date[nextType]());
      }

      if (!this.props.value) {
        this.setState({
          selectedDate: date,
          inputValue: date.format(state.inputFormat)
        });
      }
      this.props.onChange(date);
    }
  }, {
    key: 'updateSelectedDate',
    value: function updateSelectedDate(e, close) {
      var target = e.target;
      var modifier = 0;
      var viewDate = this.state.viewDate;
      var currentDate = this.state.selectedDate || viewDate;
      var date = void 0;

      if (target.className.indexOf('rdtDay') !== -1) {
        if (target.className.indexOf('rdtNew') !== -1) {
          modifier = 1;
        } else if (target.className.indexOf('rdtOld') !== -1) {
          modifier = -1;
        }
        date = viewDate.clone().month(viewDate.month() + modifier).date(parseInt(target.getAttribute('data-value'), 10));
      } else if (target.className.indexOf('rdtMonth') !== -1) {
        date = viewDate.clone().month(parseInt(target.getAttribute('data-value'), 10)).date(currentDate.date());
      } else if (target.className.indexOf('rdtYear') !== -1) {
        date = viewDate.clone().month(currentDate.month()).date(currentDate.date()).year(parseInt(target.getAttribute('data-value'), 10));
      }

      date.hours(currentDate.hours()).minutes(currentDate.minutes()).seconds(currentDate.seconds()).milliseconds(currentDate.milliseconds());

      if (!this.props.value) {
        var _open = !(this.props.closeOnSelect && close);
        if (!_open) {
          this.props.onBlur(date);
        }
        if (this.props.rangeMode) {
          if (!this.state.selectedDateEnd && this.state.selectedDate && this.state.selectedDate.isBefore(date)) {
            this.setState({
              selectedDateEnd: date,
              viewDate: date.clone().startOf('month'),
              inputValue: this.state.selectedDate.format('L') + ' - ' + date.format('L'),
              open: _open
            });
          } else {
            this.setState({
              selectedDate: date,
              selectedDateEnd: null,
              viewDate: date.clone().startOf('month'),
              inputValue: date.format('L') + ' - To other date',
              open: _open
            });
          }
        } else {
          this.setState({
            selectedDate: date,
            viewDate: date.clone().startOf('month'),
            inputValue: date.format(this.state.inputFormat),
            open: _open
          });
        }
      } else if (this.props.closeOnSelect && close) {
        this.closeCalendar();
      }

      if (this.props.rangeMode) {
        this.props.onChange({
          dateBegin: this.state.selectedDate,
          dateEnd: this.state.selectedDateEnd
        });
      } else {
        this.props.onChange(date);
      }
    }
  }, {
    key: 'setToToday',
    value: function setToToday() {
      var viewDate = this.state.viewDate;
      var currentDate = this.state.selectedDate || viewDate;
      var currentTime = void 0;

      currentTime = this.localMoment(new Date(), null, this.props);
      currentTime.hours(currentDate.hours()).minutes(currentDate.minutes()).seconds(currentDate.seconds()).milliseconds(currentDate.milliseconds());
      this.setState({
        selectedDate: currentTime,
        viewDate: currentTime.clone().startOf('month'),
        inputValue: currentTime.format(this.state.inputFormat),
        open: open
      });
      this.props.onChange(currentTime);
    }
  }, {
    key: 'openCalendar',
    value: function openCalendar() {
      var _this7 = this;

      if (!this.state.open) {
        this.setState({ open: true }, function () {
          _this7.props.onFocus();
        });
      }
    }
  }, {
    key: 'closeCalendar',
    value: function closeCalendar() {
      var _this8 = this;

      this.setState({ open: false }, function () {
        _this8.props.onBlur(_this8.state.selectedDate || _this8.state.inputValue);
      });
    }
  }, {
    key: 'handleClickOutside',
    value: function handleClickOutside(evt) {
      var _this9 = this;

      if (this.props.input && this.state.open && !this.props.open) {
        this.setState({ open: false }, function () {
          _this9.props.onBlur(_this9.state.selectedDate || _this9.state.inputValue);
        });
      }
    }
  }, {
    key: 'localMoment',
    value: function localMoment(date, format, properties) {
      var props = properties || this.props;
      var momentFn = props.utc ? _moment2.default.utc : _moment2.default;
      var m = momentFn(date, format, props.strictParsing);
      if (props.locale) {
        m.locale(props.locale);
      }
      return m;
    }
  }, {
    key: 'getComponentProps',
    value: function getComponentProps() {
      var _this10 = this;

      var formats = this.getFormats(this.props);
      var props = { dateFormat: formats.date, timeFormat: formats.time };

      this.componentProps.fromProps.forEach(function (name) {
        props[name] = _this10.props[name];
      });
      this.componentProps.fromState.forEach(function (name) {
        props[name] = _this10.state[name];
      });
      this.componentProps.fromThis.forEach(function (name) {
        props[name] = _this10[name].bind(_this10);
      });

      return props;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this11 = this;

      var ComponentToDisplay = this.viewComponents[this.state.currentView];

      return _jsx('div', {
        className: 'form-group rdt' + (this.props.className ? Array.isArray(this.props.className) ? ' ' + this.props.className.join(' ') : ' ' + this.props.className : '') + ' ' + (this.state.open ? 'rdtOpen' : '')
      }, void 0, _react2.default.createElement('input', _extends({
        key: 'i',
        type: 'text',
        className: 'form-control datetime-input ' + this.props.inputClassName
      }, this.props.inputProps, {
        onFocus: function onFocus() {
          _this11.openCalendar();
          if (_this11.props.inputProps.onFocus) {
            _this11.props.inputProps.onFocus();
          }
        },
        onChange: this.onInputChange,
        onKeyDown: this.onInputKey,
        value: this.state.inputValue
      })), _jsx('label', {
        className: 'form-control-label'
      }, void 0, this.props.label), this.props.children, this.props.inputProps && !this.props.inputProps.disabled && _jsx('button', {
        onClick: function onClick(e) {
          e.preventDefault();
          e.stopPropagation();
          _this11.setState({
            selectedDate: '',
            viewDate: _this11.localMoment().startOf('month'),
            inputValue: '',
            open: false
          });
          _this11.props.onChange(null);
        },
        className: 'rtdClear'
      }, void 0, _jsx(_zapIcons2.default, {
        icon: 'errorCircle--solid'
      })), _jsx('div', {
        className: 'rdtPicker'
      }, 'dt', _react2.default.createElement(ComponentToDisplay, _extends({}, this.getComponentProps(), { open: this.state.open }))));
    }
  }]);

  return ZapDatepicker;
}(_react.Component);

ZapDatepicker.propTypes = {
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  utc: _propTypes2.default.bool,
  input: _propTypes2.default.bool,
  label: _propTypes2.default.string,
  inputClassName: _propTypes2.default.string,
  inputProps: _propTypes2.default.shape(),
  timeConstraints: _propTypes2.default.shape(),
  viewMode: _propTypes2.default.oneOf(['months', 'days', 'time']),
  isValidDate: _propTypes2.default.func,
  defaultStart: _propTypes2.default.oneOfType([_propTypes2.default.shape(), _propTypes2.default.string]),
  open: _propTypes2.default.bool,
  strictParsing: _propTypes2.default.bool,
  closeOnSelect: _propTypes2.default.bool,
  closeOnTab: _propTypes2.default.bool,
  todayButton: _propTypes2.default.bool,
  timePicker: _propTypes2.default.bool,
  rangeMode: _propTypes2.default.bool,
  children: _propTypes2.default.node
};
ZapDatepicker.defaultProps = {
  className: '',
  inputClassName: '',
  defaultValue: '',
  inputProps: {},
  input: true,
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  timePicker: true,
  timeFormat: true,
  timeConstraints: {},
  dateFormat: true,
  strictParsing: true,
  rangeMode: false,
  closeOnSelect: false,
  closeOnTab: true,
  todayButton: false,
  utc: false
};
exports.default = (0, _reactOnclickoutside2.default)(ZapDatepicker);